"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportTimeConstraint = exports.ExportTime = void 0;
const class_validator_1 = require("class-validator");
const enums_1 = require("../../enums");
function ExportTime(property, frequencyProperty, dateProperty, validationOptions) {
    return (object, propertyName) => {
        (0, class_validator_1.registerDecorator)({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [frequencyProperty, property, dateProperty],
            validator: ExportTimeConstraint
        });
    };
}
exports.ExportTime = ExportTime;
let ExportTimeConstraint = class ExportTimeConstraint {
    validate(value, args) {
        const exportTimeCaseFrequencies = [
            enums_1.ExportFrequency.Hourly,
            enums_1.ExportFrequency.Daily,
            enums_1.ExportFrequency.Weekly,
            enums_1.ExportFrequency.Monthly
        ];
        const [frequencyPropertyName, thisFieldName, datePropertyName] = args.constraints;
        const frequencyValue = args.object[frequencyPropertyName];
        const dateValue = args.object[datePropertyName];
        let valid = true;
        switch (thisFieldName) {
            case 'heroEventStartTime':
                valid = this.validateTime(value, dateValue);
                break;
            case 'importTime':
                if ([
                    enums_1.ImportFrequency.Daily,
                    enums_1.ImportFrequency.Weekly,
                    enums_1.ImportFrequency.Monthly
                ].includes(frequencyValue)) {
                    valid = this.validateTime(value, dateValue);
                }
                break;
            case 'exportTime':
                if (exportTimeCaseFrequencies.includes(frequencyValue)) {
                    valid = this.validateTime(value, dateValue);
                }
                break;
            case 'additionalRuntimes':
                if (exportTimeCaseFrequencies.includes(frequencyValue)) {
                    if (!Array.isArray(value))
                        return false;
                    for (let runtime of value) {
                        valid = this.validateTime(runtime, dateValue);
                        if (!valid)
                            break;
                    }
                }
                break;
            case 'exportEndTime':
                if ([enums_1.ExportFrequency.Hourly].includes(frequencyValue)) {
                    valid = this.validateTime(value, dateValue);
                }
                break;
            default:
                break;
        }
        return valid; // value;
    }
    validateTime(value, dateValue) {
        // Regular expression to check if the input is a valid time in HH:mm or HH:mm:ss format
        const isValidFormat = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test(value);
        if (!isValidFormat) {
            return false; // Return false if the format is invalid
        }
        const date = new Date(dateValue);
        const [hours, minutes] = value.split(':').map(Number);
        date.setUTCHours(hours, minutes);
        value = date.toLocaleString('en-US', { timeZone: 'America/Chicago', hour: '2-digit', minute: '2-digit', hour12: false });
        const [CThours, CTminutes] = value.split(':').map(Number);
        // Extract hours and minutes to check if the time is between 22:00 and 23:59
        // Check if the time is between 22:00 and 23:59
        return !(CThours === 22 || (CThours === 23 && CTminutes <= 59));
    }
    defaultMessage(args) {
        const options = args.constraints[1];
        return options.message || `<div class="message">Exports cannot be scheduled between <span class="hightlight">10 PM</span> and <span class="hightlight">12 AM</span> Central Time due to possible system maintenance.</div>
      <div class="submessage">
        To ensure you receive a complete day’s data, update your export configuration by:
        <ol type="1">
          <li>Selecting <span class="hightlight">“Only New”</span> under the <span class="hightlight">“Record Options”</span> field</li>
          <li>Choose a start time <span class="hightlight">after 12 AM</span> CST.</li>
        </ol>
        This adjustment ensures your export captures all data without interruptions.
      </div>`;
    }
};
exports.ExportTimeConstraint = ExportTimeConstraint;
exports.ExportTimeConstraint = ExportTimeConstraint = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: 'ExportTime' })
], ExportTimeConstraint);
